export class AccountParametersModel {

    _id: any;
    user_email_as_username: boolean;
    two_factor_auth: boolean;
    expiration_password_time: number;
    pagination_items_per_page: number;

    account: {
        logo_web: string;
        code_name: string;
        pagination_items_per_page: number;
    };

    authentication: {
        two_factor_auth: boolean;
        user_email_as_username: boolean;
        special_character_password: boolean;
        number_character_password: boolean;
        lowercase_password: boolean;
        number_password_reusable: number;
        expiration_password_time: number;
        length_password_minimun: number;
    };
    keywords: { // TODO: Remover en siguiente versión
        is_active: boolean;
        empty_response: boolean;
        code_empty_response: string;
    };
    chatbot: {
        chatbot_name: string;
        node_restart_conversation: string;
        node_code_empty_response: string;
        node_code_error_response: string;
        node_code_blocked_response: string;
        limit_time_fb_hour_window: number;
        channel_default: string;
        available_channels: string[];
        watson: {
            is_active: boolean;
        };
        nlp: {
            is_active: boolean;
            model_name: string;
        };
        keywords: {
            is_active: boolean;
            empty_response: boolean;
            code_empty_response: string;
        };
        attachments: {
            node_dialog_image: string;
            node_dialog_video: string;
            node_dialog_audio: string;
            node_dialog_file: string;
        },
        confidence: {
            watson_threshold_confidence: number;
            node_code_threshold_response: string;
        }
        handover: {
            node_request_avc: string;
            node_confirm_avc: string;
            node_confirm_agent: string;
        }
        multilanguage: {
            is_active: boolean;
            detect_language: boolean;
            languages: string;
            node_code_other_language_detected: string;
        }
        authentication: {
            new_nodes_default_auth: boolean;
            is_active: boolean;
            step_1: string;
            step_2: string;
            step_2_success: string;
            step_2_fail: string;
            step_3: string;
            step_3_success: string;
            step_3_fail: string;
        },
        web: {
            dialog_home: string;
            logo: string;
            ui_border: string;
            ui_header_background: string;
            ui_header_border: string;
            ui_body_background: string;
            ui_footer_background: string;
            ui_footer_border: string;
            watson_background: string;
            watson_border: string;
            watson_font_color: string;
            user_background: string;
            user_border: string;
            user_font_color: string;
            button_background: string;
            button_border: string;
            button_font_color: string;
            time_cookie: number;
            enable_remember: boolean;
        }
    };

    terms_and_conditions: {
        is_active: boolean;
        node_welcome: string;
        node_ask_tac: string;
        node_after_tac: string;
        node_next: string;
        question: string;
        answer_yes: string;
        answer_no: string;
        url: string;
    };

    visual_recognition: {
        is_active: boolean;
        default_model: string;
        threshold: string;
        intent_after_positive_recognition: string;
        text_after_negative_recognition: string;
    };

    checkout: {
        // purchase: {
        //     notify: [{
        //         payment_method: string;
        //         message: string;
        //         param_in: [{
        //             field_in: string;
        //             field_value: string;
        //         }]
        //     }]
        // },
        // session: {
        //     page_redirect: string;
        //     timeout:string;
        //     expired_message:string;
        //     seat_limit: number;
        // },
        currencies: [{
            _id: string,
            code: string,
            description: string,
            symbol: string
        }]
        modules: {
            delivery_time: {
                is_active: boolean;
            },
            shipping_method: {
                is_active: boolean;
            }
        },
        // header: {
        //     logo: string,
        //     icono_phone: string,
        //     text_phone: string,
        //     icono_mail: string,
        //     text_mail: string
        // },
        color_buttons: {
            primary: {
                background: string,
                border: string,
                active_background: string,
                active_border: string,
                font: string
            },
            secondary: {
                background: string,
                border: string,
                active_background: string,
                active_border: string,
                font: string
            },
            third: {
                background: string,
                border: string,
                active_background: string,
                active_border: string,
                font: string
            }
        },
        message_email_page: string,
        page_title: {
            cart: string,
            mail: string,
            detail: string,
            customer: string,
            shipping_address: string,
            register_address: string,
            shipping_store: string,
            shipping_time: string,
            payment_method: string,
            payment_document: string
        }
    };
    filters: {
        color: string;
        handover_intent: string;
    };

    security: {
        ip_max_number_petitions: string;
        ip_petitions_seconds_interval: string;
        ip_max_log_entries: string;
        ip_unblock_time: string;
    }


}
